export default __webpack_public_path__ + "static/media/comment.8d2263ca.svg";